import { render, staticRenderFns } from "./security_skip_path.vue?vue&type=template&id=61e20bb2&scoped=true"
import script from "./security_skip_path.vue?vue&type=script&lang=js"
export * from "./security_skip_path.vue?vue&type=script&lang=js"
import style0 from "./security_skip_path.vue?vue&type=style&index=0&id=61e20bb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e20bb2",
  null
  
)

export default component.exports